import { useEffect, useState } from "react";
import { getAllOurStories } from "../services/api";
import { toast } from "react-toastify";

export default function OurStory() {
  const [story, setStory] = useState("");
  const [previewUrl, setPreviewUrl] = useState<string | null>(null); // For file preview
  // Fetch existing story data on component mount
  useEffect(() => {
    fetchOurStory();
  }, []);

  const fetchOurStory = async () => {
    try {
      const response = (await getAllOurStories()) as any;
      if (response.data.data && response.data.data.length > 0) {
        // console.log({response});

        const storyData = response.data.data[0]; // Get the first story (assuming only one exists)
        console.log(storyData.media_url);

        // setExistingStory(storyData); // Set existing story data
        setStory(storyData.content); // Prefill the story content
        setPreviewUrl(storyData.media_url); // Prefill the image/video preview
      }
    } catch (error) {
      console.error("Error fetching story:", error);
      toast.error("Failed to fetch story.", {
        position: "top-center",
        autoClose: 3000,
      });
    }
  };
  return (
    <div className="pb-6 md:pb-4 lg:pb-4 mt-14 md:mt-14 lg:mt-[4.5rem]">
      {/* Header - Made responsive */}
      <div className="bg-[#FBEFEF] w-full flex items-center justify-center py-6 md:py-8 lg:py-12">
        <img
          src="/images/ourStoryText.svg"
          alt="Our Story"
          className="w-[190px] md:w-[180px] lg:w-[200px]"
        />
      </div>

      <div className="max-w-5xl mx-auto px-4 md:px-6 lg:px-8">
        {/* Hero Image Section */}
        <div className="pt-12 flex item-center justify-center">
          {previewUrl && (
            <>
              {/* Preview Image/Video */}
              {previewUrl.endsWith(".jpg") || previewUrl.endsWith(".svg") ? (
                <img
                  src={previewUrl}
                  alt="Preview"
                  className=" w-[800px] h-[450px] object-cover rounded-lg"
                />
              ) : previewUrl.endsWith(".mp4") || previewUrl.endsWith(".mov") ? (
                <video
                  src={previewUrl}
                  className="w-full h-full object-cover rounded-lg"
                  controls
                />
              ) : null}
            </>
          )}
        </div>

        {/* Content Section */}
        <div className="max-w-4xl mx-auto px-4 py-8 md:py-12 space-y-12 text-center">
          {/* Decorative Divider */}
          <div className="flex justify-center">
            <img
              src={"/images/decorativeDivider.svg"}
              alt="Decorative divider"
            />
          </div>

          {/* Quote */}
          <h2 className="text-[18px] italic">
            <ul className="pl-4 space-y-2">
              {story &&
                story
                  .split(/\r\n/)
                  .map((feature, index) => <li key={index}>{feature}</li>)}
            </ul>
            {story}
          </h2>

          {/* Bottom Decorative Divider */}
          <div className="flex justify-center pt-8">
            <img src="/images/decorativeDivider.svg" alt="Decorative divider" />
          </div>
        </div>
      </div>
    </div>
  );
}
